import { useEffect, useContext, useState } from 'react'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import AOS from 'aos'
import access from 'src/utils/localAccess'
import 'aos/dist/aos.css'
import modules from 'src/app/app-module'
import acctDeletionModules from './accountDeletion/acct-deletion-module'
import dashboardModules from 'src/app/dashboard/dashboard-module'
import onboardingModules from 'src/app/onboarding/onboarding-module'
import mainModules from 'src/app/main/main-module'
import Signin from 'src/app/main/signin'
import Home from 'src/app/dashboard/home'
import OnboardingType from 'src/app/onboarding/onboardingType'
import AccountDetails from 'src/app/accountDeletion/accountDetails'
import { ThemeProvider } from "styled-components";
import { Status } from 'src/component'
import utility from 'src/utils/utility'

export const AppRoutes = () => {
    const {notifier, isConnected} = useContext(VisibilityContext)
    const {recoverStatesData, info: {theme, institutionData}} = useContext(AppInfoContext)
    const [appTheme, setAppTheme] = useState(theme || {})

    useEffect(() => {
        AOS.init({
            duration: 300,
            delay: 20,
            easing: 'linear'
        })
    }, [])

    useEffect(() => {
        let isOnline = window.navigator.onLine
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
        //recoverStatesData()
    }, [])

    useEffect(() => {
        if (institutionData?.id) {
            utility.setAppMetaData(institutionData)

            // Dynamically change the preview image when app link is shared
            // let preview = document!.getElementById('preview-img') as HTMLInputElement | any
            // preview.content = institutionData.favIcon
        }
    }, [institutionData])

    useEffect(() => {
        if (theme) setAppTheme(theme)
    }, [theme])

    useEffect(() => {
        window.addEventListener("offline", 
        () => handleInternetConnection(false)
      );
        window.addEventListener("online", 
        () => handleInternetConnection(true)
      );

      return () => {
        window.removeEventListener("offline", () => handleInternetConnection(false)
        );
        window.removeEventListener("online", () => handleInternetConnection(true));
      };
    }, [])

    function handleInternetConnection (isOnline: boolean) {
        if(!isOnline)  notifier.show('Oops...You are offline', '')
        else notifier.show('Network has been restored', '', 'success')
        access.setInternetStatus(isOnline)
        isConnected(isOnline)
    }

    return (
        <ThemeProvider theme={appTheme}>
            <Status />
            <Router>
                <Routes>
                    {
                        modules.map(module => (
                            module.name === 'Dashboard' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        dashboardModules.map(dashboardModule => (
                                            <Route {...dashboardModule.routeProps} key={dashboardModule.name}  />
                                        ))
                                    } 
                                      <Route index element={Home.routeProps.element} />
                                </Route> 
                            :
                            module.name === 'Onboarding' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        onboardingModules.map(onboardingModule => (
                                            <Route {...onboardingModule.routeProps} key={onboardingModule.name}  />
                                        ))
                                    } 
                                    <Route index element={OnboardingType.routeProps.element} />
                                </Route> 
                            :
                            module.name === 'Main' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        mainModules.map(mainModule => (
                                            <Route {...mainModule.routeProps} key={mainModule.name}  />
                                        ))
                                    } 
                                    <Route index element={Signin.routeProps.element} />
                                </Route> 
                            :
                            module.name === 'AccountDeletion' ? 
                                <Route {...module.routeProps} key={module.name} >
                                    {
                                        acctDeletionModules.map(acctDeletionModule => (
                                            <Route {...acctDeletionModule.routeProps} key={acctDeletionModule.name}  />
                                        ))
                                    } 
                                      <Route index element={AccountDetails.routeProps.element} />
                                </Route> 
                            :
                                <Route {...module.routeProps} key={module.name}  />
                        ))
                    }
                    <Route path="*" element={<Navigate to="/" />}/>
                </Routes>
            </Router>
        </ThemeProvider>
    )
}